'use strict'

export const kmSettings = {
  XbUrl: 'https://xbuffer.net',
  XbPath: 'client',
  XbUser: 'codingride',
  XbProject: 'kalimah_demo',
  XbDirectory: 'kalimah_demo',
  XbProfiles: 'profiles',
  XbAppID: 'fbb2150a483987731fb7dfcc6f2d23d667d294af20bfef71d62ec72b6b9ca19e:web'
}
